import { SummitFormattedText } from '@summit/models';

import { EboNameObject } from '../../base-classes/ebo-name-object';
import { IncentiveMethodMapping } from './incentive-method.enum';
import { IncentiveWage } from './incentive-wage';
import { IncentiveWageGroup } from './incentive-wage-group';

export class Incentive extends EboNameObject {
  tenantID: string;
  description: string;
  active: boolean;
  assignable: boolean;
  wageGroups: IncentiveWageGroup[];
  wages: IncentiveWage[]; //Client Only

  constructor(jsonData?: Partial<Incentive>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData?.wageGroups) {
        this.wageGroups = jsonData.wageGroups
          .map((item) => new IncentiveWageGroup(item))
          .sort((e1, e2) => (e1.name > e2.name ? 1 : -1));
        this.wages = this.wageGroups.flatMap((group) => group.wages);
      }
    }
    this.active ??= true;
    this.assignable ??= true;
    this.wageGroups ??= [];
    this.wages ??= [];
  }

  get defaultSort(): string {
    return this.name;
  }
  get wageSummary(): SummitFormattedText {
    if (!this.wageGroups) return null;
    const response = new SummitFormattedText();
    this.wageGroups.forEach((group) => {
      response.AddKeyValues(group.name, `${IncentiveMethodMapping[group.method]}: ${group.typeSummary}`);
      group.wages
        .sort((a, b) => (a.ruleOrder > b.ruleOrder ? 1 : -1))
        .forEach((wage) => {
          response.AddLine(`#${wage.ruleOrder}`);
          response.AddText(wage.paySummary);
        });
    });

    return response;
  }

  toShortString() {
    return this.name;
  }
}
